import { Component, OnInit,ChangeDetectorRef, ViewChild, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService , AlertService, FormatDateService}  from '../../../../services/index';
import Swal from 'sweetalert2'
declare var $ : any;
declare var jQuery : any;
declare var d3:any,moment:any;
import 'datatables.net';
import 'datatables.net-bs4';
import * as _ from "lodash";
import { ValueConverter } from '@angular/compiler/src/render3/view/template';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})

export class DashboardComponent {
    @ViewChild('reasonCodeFrm') customerContact: any;
    clientId: any = localStorage.getItem("clientId");
    userId: any = localStorage.getItem("userId");
    customerId: any = (localStorage.getItem("customerId") ? JSON.parse(localStorage.getItem("customerId")) : []);
    tierId: any = (localStorage.getItem("tierId") ? JSON.parse(localStorage.getItem("tierId")) : []);
    assetData: any = [];
    EventBarGraph: any = [];
    runTimeData: any = [];
    dataTable: any;
    assetDatalist: any = [];
    dropdownSettingsSite = {};
    dropdownSettingsAsset = {};
    site: any = '';
    asset: any = '';
    checkSiteArray: any = [];
    checkAssetArray: any = [];
    siteList: any = [];
    liveFeedlist: any = [];
    responsibiltyList: any = [];
    tempresponsibiltyList: any = [];
    eventResponsibiltyList: any = [];
    eventTempresponsibiltyList: any = [];
    mapPointerData: any = [];
    technicianList: any = [];
    temptechnicianList: any = [];
    eventTemptechnicianList:any=[];
    positions: any = [];
    livefeedData: any = [];
    isParentValue : any ;
    marker = {
        display: true,
        lat: null,
        lng: null,
        siteName: '',
        zipCode: '',
        country: '',
        state: '',
        city: '',
        address: '',
        eventState: ''
    };
    siteData: any = [];
    private bounds: google.maps.LatLngBounds;
    private map: google.maps.Map;

    zoomLevel: any;
    latitude: number;
    longitude: number;
    eventId: any = 0;
    runEventId: any = 0;
    assetId: any = 0;
    statusUrl: any = "A";
    wffNotificationId: any = 0;
    eventDatabyWff: any = [];
    RunTimeeventData: any = {};
    responsibilities: any = [];
    technicianData: any = [];
    eventTechnicianData:any=[];
    responeList: any = {};
    eventResponeList: any = {};
    eventtechnicians: any = {};
    technicians: any = {};
    eventData: any = {};
    runTimetechEventData: any = [];
    eventRunTimetechEventData: any = [];
    reasonCode: any = [];
    commentsData: any = {};
    commentListData: any = [];
    reasonCodeData: any = {};
    reasonListData: any = [];
    runTimeEventDataId: any;
    styles: any = [{"elementType":"geometry","stylers":[{"color":"#ebe3cd"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#523735"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f1e6"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#c9b2a6"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.stroke","stylers":[{"color":"#dcd2be"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#ae9e90"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#93817c"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#a5b076"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#447530"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#f5f1e6"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#fdfcf8"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#f8c967"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#e9bc62"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#e98d58"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"color":"#db8555"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#806b63"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"transit.line","elementType":"labels.text.fill","stylers":[{"color":"#8f7d77"}]},{"featureType":"transit.line","elementType":"labels.text.stroke","stylers":[{"color":"#ebe3cd"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b9d3c2"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#92998d"}]}];
    rollupEvents: any = [];
    technicalDetailData: any = [];
    responsibilityDetailData: any = [];

    selectedSite = [];
    selectedAsset = [];
    runTimePutObject:any = {
        reasonCode:{},
        users:[],
        childRunTimeEvents:[]
    };
    eventRunTimePutObject:any = {
        reasonCode:{},
        users:[],
        childRunTimeEvents:[],
        runTimeEventResponsibilities:[]
    };
    rcpId:any = null;
    rollUpList:any = [];
    eventIdArr:any = [];
    runTimeEvent:any = {};
    clientCode : any = "";
    permissionData:any=[];


    chartObj :any;
    handler: any;

    chartBarObj :any;
    handlerBar: any;

    assetDatalistPopup:any = [];
    eventDatalist:any = [];

    siteIdforGetData:any =  []
    assetIdforGetData:any =  []
    isWffLoading = false;
    checkedAssetArray :  any = [];
    performAction : number = 0;
    showAckBtn : number = 0;
    showAckErcBtn : number = 0;
    showERC : number = 0;
    showTableLoading : boolean = false;
    siteSelectAllStatus:boolean = false;
  HistoryList: any = [];
  responsibilityList: any = [] ;
  rollUpEventList: any = [];

  constructor(
    private router: Router,
    private apiService: ApiService ,
    private alertService: AlertService,
    private formatDateService: FormatDateService,
    private chRef: ChangeDetectorRef
    ) {
      this.permissionData = ApiService.permission;
  }

  width = "100%";
  height = "100%";
  type = 'doughnut3d';
  dataFormat = 'json';

  dataSource:any = {
      "chart": {
          "defaultcenterlabel": "Assets Status",
          "showlegend": "1",
      "showpercentvalues": "0",
       "aligncaptionwithcanvas": "0",
          "captionpadding": "0",
          "decimals": "1",
          // "plottooltext": "<b>$Value</b> of Assets are <b>$label</b>",
          "plottooltext": "Status.",
          "showPlotBorder": "2",
          "showShadow": "2",
          "use3DLighting": "2",
          "theme": "fusion"
            },
      "data": this.assetData
  };

  reason: any = {
      "name": "test12ddd3",
      "description": "test123",
      "isApproved": "true",
      "client": {
          "clientId": this.clientId
      },
      "approvedBy": {
          "userId": this.userId
      }
  }

  latlong:any;
  widthC = "100%";
  heightC = 430//"100%";//
  typeC = 'column3d';  
  dataFormatC = 'json';
  dataSourceC:any = {
      "chart": {
          "caption": "",
              "subcaption": "",
              "showlegend": "1",
              "xaxisname": "Event Status",
              "yaxisname": "Number of Events",
              "theme": "fusion",
      },
      "data": this.EventBarGraph
  };


  wffObj :any =  {
    "runTimeEventId": '',
    "status": "",
    "client": {
      "clientId": this.clientId
    },
    "technician": {
      "userId": this.userId
    }
  }
  errorText : any = "";
  styleExp : any  = {
    'display' : 'none'
  };

    ngOnInit() {
        this.clientCode = this.alertService.getClientCode();
        // Get all Required Lists
        this.getAssetStatus();
        this.getEventBarGraphData();
        this.getRunTimeEventData();
        this.getSiteManagementList();
        this.getAllAssetList();
        this.getRunTimeEvenListForreasonCode();

        this.getLiveFeedList();
        this.dropdownSettingsSite = {
            singleSelection: false,
            idField: 'siteId',
            textField: 'siteName',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 0,
            // limitSelection: 1000,
            allowSearchFilter: true
        };

        this.dropdownSettingsAsset = {
            singleSelection: false,
            idField: 'assetId',
            textField: 'assetName',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 0,
            allowSearchFilter: true
        };


        $('#live_table').on( 'page.dt', function () {
          const table: any = $('#run_table');
          var info = table.DataTable().page.info();
          // $('#pageInfo').html( 'Showing page: '+info.page+' of '+info.pages );
        } );

        $(document).on('hidden.bs.modal', function () {
          if($('.modal.show').length)
          {
            $('body').addClass('modal-open');
          }
        });
    }

    ngAfterViewInit(){
        this.getMapPointerData();
    }

    clickChart(event){
      var URL = 'asset/getAssetByClient';
      let apiData: any = {
        clientId: this.clientId,
        userId: this.userId,
        isAssetLive: true,
      }
      let statusValue = ''
      this.assetDatalistPopup = [];

        if ($.fn.DataTable.isDataTable('#asset_data_table')) {
            $('#asset_data_table').DataTable().destroy();
        };

        this.assetDatalistPopup = [];
      switch (event.category) {
        case 'Normal':
            statusValue = 'N'
          break;

        case 'Alarm':
            statusValue = 'A'
          break;

        case 'Warning':
            statusValue = 'W'
          break;

        case 'Suspended':
            statusValue = 'S'
          break;

        case 'No Comm':
            statusValue = 'C'
          break;

        default:
          break;
      }

        if (this.assetIdforGetData != '' && this.assetIdforGetData != undefined) {
          apiData.assetIds = this.assetIdforGetData.toString();
            // var assetString = '&assetId=' + this.assetIdforGetData;
            // var URL = URL.concat(assetString);
        }

        if (this.customerId != null && this.customerId != '') {
          apiData.customerIds = this.customerId.toString();
            // var customerString = '&customerId=' + this.customerId.toString();
            // var URL = URL.concat(customerString);
        }
        if (this.tierId != null && this.tierId != '') {
          apiData.tierIds = this.tierId.toString();
            // var tierString = '&tierId=' + this.tierId.toString();
            // var URL = URL.concat(tierString);
        }
        if (this.siteIdforGetData != '') {
          apiData.siteIds = this.siteIdforGetData.toString();
            // var siteString = '&siteId=' + this.siteIdforGetData;
            // var URL = URL.concat(siteString);
        }

        if (statusValue != '') {
          apiData.status = [statusValue];
            // var statusString = '&status=' + statusValue;
            // var URL = URL.concat(statusString);
        }
        const table: any = $('#asset_data_table');




        $('#assetListModel').modal("show");
        this.apiService.create(URL, apiData).subscribe(
            data => {
              this.chRef.detectChanges();
              if ($.fn.DataTable.isDataTable('#asset_data_table')) {
                $('#asset_data_table').DataTable().destroy();
              };
                if (data.statusCode == 100) {
                    let Arr = []
                    this.assetDatalistPopup = [];

                    let objArr =  data.responseList;
                    objArr.map((val,key)=>{
                        let objValue = val
                        if (!val.notificationPlan) {
                            objValue.notificationPlan = {};
                        }
                        if (!val.shiftGroup) {
                            objValue.shiftGroup = {};
                        }
                        if (!val.customer) {
                            objValue.customer = {};
                        }
                        if (!val.site) {
                            objValue.site = {};
                        }
                        Arr.push(objValue);
                    });

                    this.assetDatalistPopup = JSON.parse(JSON.stringify(Arr));
                    let self = this
                    setTimeout(() => {
                      self.dataTable = $('#asset_data_table').DataTable({

                        "bDestroy": true,
                        "destroy":true,
                        "columnDefs": [{
                            "orderable": false,
                            "targets": 8
                        }],
                    });
                    }, 500);

                }
                else {
                    this.assetDatalistPopup = [];
                    this.chRef.detectChanges();
                    const table: any = $('#asset_data_table');
                    setTimeout(() => {
                      this.dataTable = table.DataTable({
                          "order": [],
                          "destroy":true,
                          "bDestroy": true,
                          "columnDefs": [{
                              "orderable": false,
                              "targets": 8
                          }],

                      });

                    }, 500);
                }
            },
            error =>{
              this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
             }
        );
    }

    clickChartC(event){
      this.showTableLoading = true;
      var URL = 'wffnotification/getEventListData';
      let statusValue = ''
      var runtimeUrlStatus = 'asset/getRuntimeLiveFeedByStatus?clientId='+this.clientId+'&userId='+this.userId+'';

      let apiData : any = {
        clientId: this.clientId,
        userId: this.userId
      }
      
      if(event && event.categoryX){
        if (event.categoryX == "In Progress Runtime Events") {
          apiData.search = 'InProgress Runtime';
          // var statusApi  = '&search=InProgress Runtime';
          // var URL = URL.concat(statusApi);          
        }
        if (event.categoryX == "Open Runtime Events") {
          apiData.search = 'Open Runtime';
          // var statusApi  = '&search=Open Runtime';
          // var URL = URL.concat(statusApi);          
        }
        if (event.categoryX == "Acknowledgement Pending") {
          apiData.search = 'Notification Pending';
          // var statusApi  = '&search=Notification Pending';
          // var URL = URL.concat(statusApi);          
        }
      }

        if (this.assetIdforGetData != '' && this.assetIdforGetData != undefined) {
          apiData.assetIds = this.assetIdforGetData.toString();
            // var assetString = '&assetId=' + this.assetIdforGetData;
            // var URL = URL.concat(assetString);
        }

        if (this.customerId != null && this.customerId != '') {
          apiData.customerIds = this.customerId.toString();
            // var customerString = '&customerId=' + this.customerId.toString();
            // var URL = URL.concat(customerString);
        }
        if (this.tierId != null && this.tierId != '') {
          apiData.tierIds = this.tierId.toString();
            // var tierString = '&tierId=' + this.tierId.toString();
            // var tierString = '&tiers=' + this.tierId.toString();//changed as per requirements on 9 december 2019
            // var URL = URL.concat(tierString);
        }
        if (this.siteIdforGetData != '') {
          apiData.siteIds = this.siteIdforGetData.toString();
            // var siteString = '&siteId=' + this.siteIdforGetData;
            // var URL = URL.concat(siteString);
        }

        if ($.fn.DataTable.isDataTable('#data_table_Event')){
          $('#data_table_Event').DataTable().destroy();
        };

        $('#notificationListModel').modal("show");
        this.eventDatalist = []

        this.apiService.create(URL, apiData).subscribe(
          data => {
            if(data.statusCode == 100){
              this.eventDatalist = data.responseList;
               if ($.fn.DataTable.isDataTable('#data_table_Event')){
                    $('#data_table_Event').DataTable().destroy();
                  };
              this.chRef.detectChanges();
              const table: any = $('#data_table_Event');
              let self = this
              setTimeout(() => {
                self.dataTable = table.DataTable();
              }, 500);


            }else{
               this.eventDatalist = [];
               if ($.fn.DataTable.isDataTable('#data_table_Event')){
                    $('#data_table_Event').DataTable().destroy();
                  };
               this.chRef.detectChanges();
              const table: any = $('#data_table_Event');

              let self = this
              setTimeout(() => {
                self.dataTable = table.DataTable();
              }, 500);


            }
            this.showTableLoading = false;
          },
         error =>{
              this.showTableLoading = false;
              this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
         }
        );
    }

    initializedChartD($event) {
      this.chartObj = $event.chart;
    }

    initialized($event){
      this.chartBarObj = $event.chart;
    }

    // Function to format Date
    DateFormat(startDate, gmtOffset){
        return this.formatDateService.formatDate(startDate, gmtOffset);
    }
    
    // Function to format Date
    DateFormatEvent(startDate, gmtOffset){
      let d1  = new Date(startDate)
      var d = moment(startDate, "YYYY-MM-DD HH:mm:ss:SSSZ").toDate();
      
      if(startDate){
      	var formattedDate = /* moment(d1).format("MM-DD-YYYY HH:mm:ss")// */moment(d).format("MM-DD-YYYY HH:mm:ss");
        return formattedDate;
      }else{
        return "";
      }
    }

    /* Update asset status chart after api response */
    updateStatusData() {
        this.dataSource = {
            "chart": {
           "defaultcenterlabel": "Assets Status",
            "showlegend": "1",
        "showpercentvalues": "0",
         "aligncaptionwithcanvas": "0",
            "captionpadding": "0",
            "decimals": "1",
            // "plottooltext": "<b>$Value</b> of Assets are <b>$label</b>",
            "plottooltext": "<b>$Value</b> of <b>$sum</b> Assets are in <b>$label</b> Status.",
            "showPlotBorder": "2",
            "showShadow": "2",
            "use3DLighting": "2",
            "theme": "gammel" },
            "data": this.assetData
        };

        setTimeout(() => {
          this.handler = this.clickChart.bind(this);
          // this.message = this.clickPlotMsg;
          // this.attached = true;
          // this.chartObj.addEventListener('dataplotClick', this.handler);
        }, 1000);
    }

  /* Update event chart after api response */
  updateEventStatusData() {
    this.dataSourceC = {
    "chart": {
      "caption": "",
      "subcaption": "",
      "showlegend": "1",
      "xaxisname": "Event Status",
      "yaxisname": "Number of Events",
      "theme": "fusion",
    },
    "data": this.EventBarGraph,

    };


    setTimeout(() => {
      this.handlerBar = this.clickChartC.bind(this);
      // this.chartBarObj.addEventListener('dataplotClick', this.handlerBar);
    }, 1000);

  }

// Zoom Functionality
getBoundsZoomLevel(bounds, mapDim) {
  var WORLD_DIM = {
      height: 256,
      width: 256
  };
  var ZOOM_MAX = 21;

  function latRad(lat) {
      var sin = Math.sin(lat * Math.PI / 180);
      var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
      return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
  }

  function zoom(mapPx, worldPx, fraction) {
      return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
  }

  var ne = bounds.getNorthEast();
  var sw = bounds.getSouthWest();

  var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

  var lngDiff = ne.lng() - sw.lng();
  var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

  var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
  var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);
  return Math.min(latZoom, lngZoom, ZOOM_MAX);
}

  // Graph functions
  onMapReady(map?:any) {
      this.map = map;
      this.bounds = new google.maps.LatLngBounds();
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    // this.map.d

    if(this.chartObj !== undefined){ this.chartObj.dispose(); }
    if(this.chartBarObj !== undefined){ this.chartBarObj.dispose(); }
    
  }

  // Graph functions
  onMarkerInit(marker) {
    let loc = new google.maps.LatLng(marker.position[0], marker.position[1]);

    this.bounds.extend(loc);
    this.zoomLevel = this.getBoundsZoomLevel(this.bounds, {
      "height": 330,
      "width": 550
    });

    var data = this.bounds.getCenter();
    this.map.fitBounds(this.bounds);
    this.map.setCenter(this.bounds.getCenter());

    var that = this;
    setTimeout(()=>{
        this.latitude = data.lat();
        this.longitude = data.lng();
        this.zoomLevel = this.zoomLevel;
    },3000)

    this.chRef.detectChanges();
  }

  /* On Item Select Site */
  onItemSelectSite(item: any) {
    var exist = this.checkSiteArray.indexOf(item.siteId.toString());
    if (exist == '-1') {
        this.checkSiteArray.push(item.siteId.toString());
        if(this.siteList.length == this.checkSiteArray.length) {
          this.siteSelectAllStatus = true;
        }
        this.getAllAssetList();
    }
  }

  /* On Item DeSelect Site */
  onItemDeselectSite(item: any) {
    var exist = this.checkSiteArray.indexOf(item.siteId.toString());
    this.checkedAssetArray = [];
    this.siteSelectAllStatus = false;
    if (exist != '-1') {
        this.checkSiteArray.splice(exist, 1);
        this.getAllAssetList();
    }
  }

  /* On All Select Site */
  onSelectAllSite(items: any) {
    this.checkSiteArray = [];
    this.siteSelectAllStatus = true;
    Object.keys(items).forEach(key => {
        this.checkSiteArray.push(items[key]['siteId'].toString());
    });
    this.getAllAssetList();
  }

  /* On All DeSelect Site */
  onDeSelectAllSite() {
    this.checkSiteArray = [];
    this.checkAssetArray = [];
    this.siteSelectAllStatus = false;
    this.getAllAssetList();
  }

  /* On Item Select Asset */
  onItemSelectAsset(item: any) {
      var exist = this.checkAssetArray.indexOf(item.assetId.toString());
      if (exist == '-1') {
          this.checkAssetArray.push(item.assetId.toString());
      }
  }

  /* On Item DeSelect Asset */
  onItemDeselectAsset(item: any) {
      var exist = this.checkAssetArray.indexOf(item.assetId.toString());
      if (exist != '-1') {
          this.checkAssetArray.splice(exist, 1);
      }
  }

  /* On All Select Asset */
  onSelectAllAsset(items: any) {
      this.checkAssetArray = [];
      Object.keys(items).forEach(key => {
          this.checkAssetArray.push(items[key]['assetId'].toString());
      });
  }

  /* On All DeSelect Site */
  onDeSelectAllAsset() {
      this.checkAssetArray = [];
  }

  /* On Search */
  seachRecord() {
    // if(this.checkSiteArray.length > 0 || this.checkAssetArray > 0){
    this.site = this.checkSiteArray;
    this.asset = this.checkAssetArray;
    this.getLiveFeedList();
    this.getMapPointerData();
    this.getEventBarGraphData();
    this.getAssetStatus();
    this.getRunTimeEventData();
    this.onMapReady();

    let value = [];

    if (this.site && this.site.length) {
      this.site.map((val,index) =>{
        value.push(val);
      })
      this.siteIdforGetData = value;

    } else {
      this.siteIdforGetData = [];
    }

    let assetValue = []
    if (this.asset && this.asset.length) {
      this.asset.map((val,index) =>{
        assetValue.push(val);
      })
      this.assetIdforGetData = assetValue;

    } else {
      this.assetIdforGetData = [];
    }


    // }
  }

  /* Reset Search Record */
  resetSearch() {
    // if(this.checkSiteArray.length > 0 || this.checkAssetArray > 0){
    this.site = '';
    this.asset = '';
    this.checkSiteArray = [];
    this.checkAssetArray = [];
    this.siteIdforGetData = [];
    this.assetIdforGetData = [];
    var self = this;
    setTimeout(()=>{
      self.getSiteManagementList();
      self.getAllAssetList();
      self.getLiveFeedList();
      self.getMapPointerData();
      self.getEventBarGraphData();
      self.getAssetStatus();
      self.getRunTimeEventData();
      self.onMapReady();
    }, 2000);

    this.selectedSite = [];
    this.selectedAsset = [];
  // }
  }

/* Get Asset Status */
getAssetStatus() {
    //http://localhost:8764/api/v1/asset/assetStatusCountforClientDashboard?clientId=1&userId=2&tierId=1,2&siteId=8,9&assetId=233,244
    var URL = 'asset/getAssetStatusGraphData?clientId=' + this.clientId + '&userId=' + this.userId;
    let URLStr = 'asset/getAssetStatusGraphData'
    let ReqObj:any = {
      clientId:this.clientId,
      userId:this.userId
    }
    if (this.tierId != null && this.tierId != '') {
        var tierString = '&tierId=' + this.tierId.toString();
        var URL = URL.concat(tierString);
        ReqObj.tierIds = this.tierId.toString()
    }
    if (this.site != '') {
        var siteString = '&siteId=' + this.site;
        var URL = URL.concat(siteString);
        ReqObj.siteIds = this.site.toString()

    }
    if (this.asset != '') {
        var assetString = '&assetId=' + this.asset;
        var URL = URL.concat(assetString);
        ReqObj.assetIds = this.asset.toString()
    }
    if (this.customerId != null && this.customerId != '') {
        var customerString = '&customerId=' + this.customerId.toString();
        var URL = URL.concat(customerString);
        ReqObj.customerIds = this.customerId.toString();
    }
    this.apiService.create(URLStr, ReqObj).subscribe(
      data => {
        if (data.statusCode == 100) {

          let Arr = [];
          let valueArr = data.responseList

          valueArr.map((val, key)=>{
            if(val.fill){
              // delete val.fill;
            }
            Arr.push(val);
          })

          this.assetData = Arr;
          var that = this;
          
          Object.keys(that.assetData).forEach(key => {
            // that.assetData[key]['fill'] = am4core.color() 
            if (that.assetData[key]['label'] == "A") {
                that.assetData[key]['label'] = 'Alarm';
                // that.assetData[key]['link'] = '/asset-management/A/'+this.asset;
            }
            if (that.assetData[key]['label'] == "N") {
                that.assetData[key]['label'] = 'Normal';
                // that.assetData[key]['link'] = '/asset-management/N/'+this.asset;
            }
            if (that.assetData[key]['label'] == "W") {
                that.assetData[key]['label'] = 'Warning';
                // that.assetData[key]['link'] = '/asset-management/W/'+this.asset;
            }
            if (that.assetData[key]['label'] == "S") {
                that.assetData[key]['label'] = 'Suspended';
                // that.assetData[key]['link'] = '/asset-management/O/'+this.asset;
            }
            if (that.assetData[key]['label'] == "C") {
              that.assetData[key]['label'] = 'No Comm';
              // that.assetData[key]['link'] = '/asset-management/O/'+this.asset;
            }
          });



let chart = am4core.create("statusPie", am4charts.PieChart);
chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

chart.legend = new am4charts.Legend();

chart.legend.maxHeight = 90;
chart.legend.labels.template.fontSize = 10
chart.legend.itemContainers.template.tooltipText = "{category}";
chart.legend.labels.template.truncate = true;


chart.legend.scrollable = true;
chart.legend.valueLabels.template.disabled = true;

chart.legend.valueLabels.template.align = "left";

chart.legend.labels.template.text = "{category}";
chart.data = Arr

chart.innerRadius = 50;

let series = chart.series.push(new am4charts.PieSeries());
series.dataFields.value = "value";
series.dataFields.category = "label";
chart.configField = "config"
series.configField = "config"
series.slices.template.propertyFields.fill = "fill"
chart.legend.padding(0,10,10,10);
// chart.padding(20,10,20,10); 

let self = this
series.slices.template.events.on("hit", function(ev) {
    let series = ev.target.dataItem.component;
    that.clickChart(ev.target.dataItem)

  });
  series.alignLabels = true;
  series.slices.template.cornerRadius = 5;
  series.labels.template.text = "{value.percent.formatNumber('#.0')}%";

          setTimeout(()=>{
            that.updateStatusData();
          },2000)

      } else {
        this.assetData = [];
        this.updateStatusData();
      }
    },
    error =>{
    //  this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
    }
  );
}


openModal () {
  $("#showModal").click();
}

// Function get Graph Data
getEventBarGraphData() {
    var URL = 'runTimeEvent/getClientDashboardCounts';
    let apiData : any = {
      clientId: this.clientId,
      userId: this.userId
    }   

    if (this.tierId != null && this.tierId != '') {
      apiData.tierIds = this.tierId.toString();
        // var tierString = '&tierId=' + this.tierId.toString();
        // var URL = URL.concat(tierString);
    }
    if (this.site != '') {
      apiData.siteIds = this.site.toString();;
        // var siteString = '&siteId=' + this.site;
        // var URL = URL.concat(siteString);
    }
    if (this.asset != '') {
      apiData.assetIds = this.asset.toString();;
        // var assetString = '&assetId=' + this.asset;
        // var URL = URL.concat(assetString);
    }
    if (this.customerId != null && this.customerId != '') {
      apiData.customerIds = this.customerId.toString();
        // var customerString = '&customerId=' + this.customerId.toString();
        // var URL = URL.concat(customerString);
    }
    this.apiService.create(URL, apiData).subscribe(
        data => {
        if (data.statusCode == 100) {

        let Arr = [];
        let valueArr = data.responseList

        valueArr.map((val, key)=>{
          if(val.fill){
            // delete val.fill;
          }
          Arr.push(val);
        })

        this.EventBarGraph = Arr;

        var that = this;
        Object.keys(that.EventBarGraph).forEach(key => {
              // that.EventBarGraph[key]['fill'] = am4core.color(that.EventBarGraph[key]['fill'])

          if (that.EventBarGraph[key]['label'] == "Runtime Open") {
              // that.EventBarGraph[key]['link'] = '/notification-event/1';
          }
          if (that.EventBarGraph[key]['label'] == "In-Progress") {
              // that.EventBarGraph[key]['link'] = '/notification-event/2';
          }
          if (that.EventBarGraph[key]['label'] == "Not Acknowledged") {
              // that.EventBarGraph[key]['link'] = '/notification-event/0';
          }
        });


// Create chart instance
let chart = am4core.create("eventbargraph", am4charts.XYChart3D);

// Add data
chart.data = Arr


// Create axes
let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
categoryAxis.dataFields.category = "label";
categoryAxis.renderer.labels.template.rotation = 0;
categoryAxis.renderer.labels.template.hideOversized = false;
categoryAxis.renderer.minGridDistance = 60;
categoryAxis.renderer.labels.template.horizontalCenter = "right";
categoryAxis.renderer.labels.template.verticalCenter = "middle";
// categoryAxis.tooltip.label.rotation = 0;
categoryAxis.renderer.labels.template.rotation = 310;

let label = categoryAxis.renderer.labels.template;
label.wrap = false;
label.truncate = true;
label.tooltipText = "{category}";
label.width = am4core.percent(25);
categoryAxis.renderer.labels.template.location = 0.5

// categoryAxis.renderer.grid.template.location = 0;

let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
valueAxis.title.text = "Events";
valueAxis.title.fontWeight = "bold";

// Create series
let series = chart.series.push(new am4charts.ConeSeries());
series.dataFields.valueY = "value";
series.dataFields.categoryX = "label";
// series.name = "Events";
series.tooltipText = "{categoryX}\n[bold]{valueY}[/]";
// series.columns.template.fillOpacity = .8;
series.columns.template.width = am4core.percent(40);
series.columns.template.propertyFields.fill = "fill"
// series.tooltip.rotation


let columnTemplate = series.columns.template;
// columnTemplate.strokeWidth = 2;
columnTemplate.strokeOpacity = 1;
columnTemplate.propertyFields.stroke = 'fill'//am4core.color("#FFFFFF");

chart.cursor = new am4charts.XYCursor();
chart.cursor.lineX.strokeOpacity = 0;
chart.cursor.lineY.strokeOpacity = 0;

series.columns.template.events.on("hit", function(ev) {
    this.clickChartC(ev.target.dataItem)
  }, this);

        setTimeout(()=>{
          that.updateEventStatusData();
        },2000)

        } else {
          this.EventBarGraph = [];
          this.updateEventStatusData();
        }
        },
        error =>{
          // this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
        }
    );
}

/* Get Site Management list */
getSiteManagementList() {
    // var URL = 'site/getSiteByClient?alphabateSortingOreder=1&clientId=' + this.clientId + '&userId=' + this.userId;
    var URL = 'site/getSiteDropDownListByClient?clientId='+this.clientId+'&userId='+this.userId;
    if (this.customerId != null && this.customerId != '') {
        var customerString = '&customerId=' + this.customerId.toString();
        var URL = URL.concat(customerString);
    }
    if (this.tierId != null && this.tierId != '') {
        var tierString = '&tierId=' + this.tierId.toString();
        var URL = URL.concat(tierString);
    }
    this.apiService.getAll(URL).subscribe(
      data => {
          if (data.statusCode == 100) {
              this.siteList = data.responseList;
          } else {
              this.siteList = [];
          }
      },
      error =>{
        this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
       }
    );
    }

    // Getting Asset List
    getAllAssetList() {
        var URL = 'asset/getAssetDropDownByClient'
        let apiData: any = {
          clientId: this.clientId ? this.clientId : null,
          userId: this.userId ? this.userId : null,
        }
        // customerId: this.customerId.length > 0 ? this.customerId : null,
        // tierId: this.tierId.length > 0 ? this.tierId : null,
        // siteId: this.checkSiteArray.length > 0 ? this.checkSiteArray : null

      //   if (apiData.siteId != null) {
      //     if(apiData.siteId.length == 1000) {          
      //       this.alertService.sweetMessage('error','Can not select more than 1000 sites');
      //     }
      // }
         if (this.customerId != null && this.customerId != '') {
           apiData.customerId = this.customerId;
           //  var customerString = '&customerId=' + this.customerId.toString();
            //  var URL = URL.concat(customerString);
         }
        if (this.tierId != null && this.tierId != '') {
          apiData.tierId = this.tierId.toString();
          // var tierString = '&tierId=' + this.tierId.toString();
          //  var URL = URL.concat(tierString);
        }
         if (this.checkSiteArray.length != 0) {
             this.site = this.checkSiteArray.toString();
             apiData.siteId = this.checkSiteArray.toString();
            // var siteString = '&siteId=' + this.site;
          //  var URL = URL.concat(siteString);
         }

        this.apiService.create(URL, apiData).subscribe(
            data => {
                if (data.statusCode == 100) {
                    this.assetDatalist = data.responseList;
                } else {
                    this.assetDatalist    = [];
                }
                this.selectedAsset = [];
            },
            error =>{
              this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
             }
        );
    }

/* Get Run Time Event list */
getRunTimeEventData() {
    // commented as per requirements on 9 december 2019
    // var URL = 'runTimeEvent/getWaitingApprovalEvents?clientId=' + this.clientId + '&userId=' + this.userId + '&startlimit=0&endlimit=10';
    // removed limits as per requirement on 9 december 2019
    var URL = 'runTimeEvent/getWaitingApprovalEvents';
    let apiData : any = {
      clientId: this.clientId,
      userId: this.userId
    }
    //var URL = 'runTimeEvent/runTimeEventList?clientId=' + this.clientId + '&userId=' + this.userId + '&startlimit=0&endlimit=10';
    if (this.tierId != null && this.tierId != '') {
      apiData.tierIds = this.tierId.toString();
        // var tierString = '&tierIds=' + this.tierId.toString();
        // var URL = URL.concat(tierString);
    }
    if (this.site != '') {
      apiData.siteIds = this.site.toString();
        // var siteString = '&siteIds=' + this.site;
        // var URL = URL.concat(siteString);
    }
    if (this.asset != '') {
      apiData.assetIds = this.asset.toString();
        // var assetString = '&assetIds=' + this.asset;
        // var URL = URL.concat(assetString);
    }
    if (this.customerId != null && this.customerId != '') {
      apiData.customerIds = this.customerId.toString();
        // var customerString = '&customerIds=' + this.customerId.toString();
        // var URL = URL.concat(customerString);
    }
    this.apiService.create(URL, apiData).subscribe(
      data => {
        if (data.statusCode == 100) {
            this.runTimeData = data.responseList;
            if ($.fn.DataTable.isDataTable('#run_table')) {
                $('#run_table').DataTable().destroy();
            };
            this.chRef.detectChanges();
            const table: any = $('#run_table');
            this.dataTable = table.DataTable({"order": [],"columnDefs": [{ "orderable": false, "targets": [5] }]});
        } else {
          this.runTimeData = [];
          if ($.fn.DataTable.isDataTable('#run_table')) {
              $('#run_table').DataTable().destroy();
          };
          this.chRef.detectChanges();
          const table: any = $('#run_table');
          this.dataTable = table.DataTable({"order": [],"columnDefs": [{ "orderable": false, "targets": [5] }]});
        }
      },
       error =>{
        this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
         }
    );
}

  /* Get Live Feed Data */
  getLiveFeedList() {
    var URL = 'wffnotification/getEventList';
    let apiData : any = {
      clientId: this.clientId,
      userId: this.userId,
      startlimit: 0,
      endlimit: 2000
    }

    // if (this.tierId != null && this.tierId != '') {
    if (this.tierId != null && this.tierId != '') {
      apiData.tierIds =  this.tierId.toString();
        // var tierString = '&tiers=' + this.tierId.toString();
        // var URL = URL.concat(tierString);
    }
    if (this.site != '') {
      apiData.siteIds = this.site.toString();;
        // var siteString = '&siteId=' + this.site;
        // var siteString = '&sites=' + this.site;
        // var URL = URL.concat(siteString);
    }
    if (this.asset != '') {
      apiData.assetIds = this.asset.toString();;
        // var assetString = '&assetId=' + this.asset;
        // var assetString = '&assets=' + this.asset;
        // var URL = URL.concat(assetString);
    }
    if (this.customerId != null && this.customerId != '') {
      apiData.customerIds = this.customerId.toString();
        // var customerString = '&customers=' + this.customerId.toString();
        // var URL = URL.concat(customerString);
    }

    this.isWffLoading = true;

    this.apiService.create(URL, apiData).subscribe(
      data => {
        this.isWffLoading = false;

        if (data.statusCode == 100) {
          this.liveFeedlist = data.responseList;
          if ($.fn.DataTable.isDataTable('#live_table')) {
              $('#live_table').DataTable().destroy();
          };
          this.chRef.detectChanges();
          const table: any = $('#live_table');
          this.dataTable = table.DataTable({"order": [],"columnDefs": [{ "orderable": false, "targets": [0,9] }], "search": {
            "smart": false
          }});
        } else {
          this.liveFeedlist = [];
          if ($.fn.DataTable.isDataTable('#live_table')) {
              $('#live_table').DataTable().destroy();
          };
          this.chRef.detectChanges();
          const table: any = $('#live_table');
          this.dataTable = table.DataTable({"order": [],"columnDefs": [{ "orderable": false, "targets": [0,9] }]});

        }
      },
      error =>{
        this.isWffLoading = false;
      }
    );
  }

   /** Function to Sort Response Data **/
  sortDataTableData(items,sortBy,desc){
       if (sortBy && sortBy != null) {
              items = items.sort((a, b) => {
               const sortA = a[sortBy];
               const sortB = b[sortBy];
               if (desc) {
                   if (sortA < sortB) return 1;
                   if (sortA > sortB) return -1;
                   return 0;
               } else {
                   if (sortA < sortB) return -1;
                   if (sortA > sortB) return 1;
                   return 0;
               }
           });
          return items;
       }else{
          return items;
       }
  }


  // Function to filter Data
  getLiveFilterData(e) {
    if (e.target.value == 'alarm') {
        this.statusUrl = "A"
    } else if (e.target.value == 'warning') {
        this.statusUrl = "W"
    } else if (e.target.value == 'normal') {
        this.statusUrl = "N"
    } else if (e.target.value == 'offline') {
        this.statusUrl = "S"
    } else if (e.target.value == 'nocomm') {
        this.statusUrl = "C"
    }
    this.getMapPointerData();
  }

  /* Get tier list */
  getMapPointerData() {
    var URL = 'asset/getAssetByClient';
    let apiData: any = {
      clientId: this.clientId,
      userId: this.userId,
      isAssetLive: true,
    }
    if (this.tierId != null && this.tierId != '') {
      apiData.tierIds = this.tierId.toString();
        // var tierString = '&tierId=' + this.tierId.toString();
        // var URL = URL.concat(tierString);
    }
    if (this.site != '') {
      apiData.siteIds = this.site.toString();
        // var siteString = '&siteId=' + this.site;
        // var URL = URL.concat(siteString);
    }
    if (this.customerId != null && this.customerId != '') {
      apiData.customerIds = this.customerId.toString();
        // var customerString = '&customerId=' + this.customerId.toString();
        // var URL = URL.concat(customerString);
    }
    if (this.statusUrl != '') {
      apiData.status = [this.statusUrl];
        // var statusString = '&status=' + this.statusUrl.toString();
        // var URL = URL.concat(statusString);
    }
    if (this.asset != '') {
      apiData.assetIds = this.asset.toString();
        // var assetString = '&assetId=' + this.asset;
        // var URL = URL.concat(assetString);
    }

    this.apiService.create(URL, apiData).subscribe(
      data => {
        if (data.statusCode == 100) {
          this.mapPointerData = data.responseList;
          this.positions = [];
          this.errorText = "";
          this.styleExp.display = "none";
          // this.zoomLevel = 6;

          let position = [];
          Object.keys(this.mapPointerData).forEach(key => {
            if(this.mapPointerData[key]['latitude'] != null && this.mapPointerData[key]['longitude'] != null){

              if (this.mapPointerData[key]['alarmState'] == "Offline") {
                this.mapPointerData[key]['alarmState'] = "Suspended";
              }
              // this.latitude = this.mapPointerData[key]['latitude']
              // this.longitude = this.mapPointerData[key]['longitude']
              position.push([
                this.mapPointerData[key]['latitude'],
                this.mapPointerData[key]['longitude'],
                this.mapPointerData[key]['alarmState'],
                this.mapPointerData[key]['customerName'],
                this.mapPointerData[key]['assetDescription'],
                this.mapPointerData[key]['site'],
                this.mapPointerData[key]['city'],
                this.mapPointerData[key]['state'],
                this.mapPointerData[key]['country'],
                this.mapPointerData[key]['lastEventTime'],
                this.mapPointerData[key]['assetId'],
                this.mapPointerData[key]['name'],
                this.mapPointerData[key]['proximity'],
              ]);
            }
          });

            var self = this;
            setTimeout(()=>{
              self.positions = position;
            },3000);

        } else {
          if(data.responseMessage != 'Permission not granted') {
            this.errorText = data.responseMessage;
            this.styleExp.display = "block";
            this.mapPointerData = [];
            this.positions = [];
          }else {
            // this.errorText = data.responseMessage;
            // this.styleExp.display = "block";
            this.mapPointerData = [];
            this.positions = [];
          }
        }
      },
      error =>{
        this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
      }
    );
  }

  updateEvent(){
    let self = this;
    if (Object.keys(this.eventtechnicians).length >= 1) {
      let obj = _.find(this.technicianList, function(o) {
        return o.userId == self.eventtechnicians.userId;
      });
      this.eventTechnicianData.push(obj);
    }

    let user = [];
    this.eventTechnicianData.map((val,index)=>{
      user.push({userId:val.userId})
    })


    if(this.isParentValue == true){
      this.eventRunTimePutObject.runTimeEventId = this.runTimeEventDataId;
    }

    if(this.rollUpList.length == 0 && this.isParentValue == false) {
      this.eventRunTimePutObject.runTimeEventId = this.runTimeEventDataId;
    }
    else if(this.eventIdArr.length == 0) {
      this.eventRunTimePutObject.runTimeEventId = this.runTimeEventDataId;
    }
    let res = [];

    this.responsibilities.map((val,index)=>{
        res.push({
            "runTimeEventRcpId": this.rcpId,
            "responsibilityListMember": {
              "listMemberId": val.listMemberId
            },

            "downtime": val.downtime
          })
    })


    this.eventRunTimePutObject.runTimeEventResponsibilities = res;
    this.eventRunTimePutObject.users = user;
    this.eventRunTimePutObject.status = this.eventRunTimetechEventData.status;

    // Deep copy
    var newObject = jQuery.extend(true, {}, this.eventRunTimePutObject);

    if(newObject.users.length == 0) {
      newObject.users = null
    }

    if(newObject.childRunTimeEvents.length == 0){
      newObject.childRunTimeEvents = null;
    }
    // return;

    this.apiService.update('runTimeEvent/updateRunTimeEvents?userId='+this.userId, newObject).subscribe(
      data => {
        if (data.statusCode == 100) {
          this.alertService.sweetMessage('success',data.responseMessage);
        }else{
          this.alertService.sweetMessage('error',data.responseMessage);
        }
      },
      error => {
        this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
      }
    );
  }


/* Get EventDetail by WffNotification ID Popup data */
getEventDetailbyWff(eventdetail) {
    this.isParentValue = eventdetail.isParent;

    if (eventdetail.runTimeEventId) {
        this.assetId = eventdetail.assetId;
        this.runTimeEventDataId  = eventdetail.runTimeEventId;
        this.eventTechnicianData = [];
        this.eventtechnicians    = {};
        this.eventResponeList    = {};
        this.getEventTechnicianList();
        this.eventGetResponsibilty();
        this.getEventRunTimeEvenList();
        this.getRunTimeEvenListForreasonCode();
        this.getRollupEvent(eventdetail)
    }

    this.runEventId        = eventdetail.runTimeEventId;
    this.wffNotificationId = eventdetail.notificationId;

    var URL = 'runTimeEvent/runTimeEventDetail?runTimeEventId='+this.runEventId

    if (eventdetail.notificationId != null) {
        var URL = 'wffnotification/getEventDetailByWffNotificationId?wffNotificationId=' + this.wffNotificationId + '&clientId=' + this.clientId;
    }

    if(eventdetail.runTimeStatus == 1) {
        this.wffObj = {
          "runTimeEventId": this.runEventId,
          "status": eventdetail.runTimeStatus,
          "client": {
            "clientId": this.clientId
          },
          "technician": {
            "userId": this.userId
          }
        }

        this.apiService.update('runTimeEvent/assignOwnerTechnician',this.wffObj).subscribe(
            data => {
              if (data.statusCode == 100) {
                // $("#showModal").click();
              }
              else
                {
                  // $("#showModal").click();
                  this.alertService.sweetMessage('error',data.responseMessage);
                }
            },
            error =>
              { this.alertService.errorMessage(error, error.status, "Something went wrong, please try again "); }
        );
    }


    this.apiService.getAll(URL).subscribe(
        data => {
            if (data.statusCode == 100)
              {
                this.eventDatabyWff = data.response;
                // $("#showModal").click()
               }
        },
        error =>{
          this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
        }
    );
}

    /* Get Item for Approval popup data */
    getItemforApprovalData(event) {
        this.responsibilities = [];
        this.technicians = {};
        this.technicianData = []
        this.responeList = {};
        this.eventIdArr = [];
        this.runTimeEvent = event
        this.eventId = event.runTimeEventId ;
        this.assetId = event.runTimeCollectionPoint.asset.assetId
        this.getTechnicianList();
        this.getResponsibilty();
        this.getRollupEvent(event);
        this.apiService.getAll('runTimeEvent/runTimeEventDetail?runTimeEventId=' + this.eventId).subscribe(
            data => {
                if (data.statusCode == 100) {
                    this.livefeedData = data.response;
                    this.responsibilities = this.livefeedData.runTimeEventResponsibilities;
                     this.technicianData = this.livefeedData.users

                    this.RunTimeeventData.runTimeEventId = this.livefeedData.runTimeEventId;
                }
            },
           error =>{
            this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
             }
        );
    }

    // Function to submit Reason
    SubmitReason() {
        this.reason.name = $('.reasonCode').val();
        this.reason.description = $('.reasonData').val();
        this.apiService.create('reasonCode/createReasonCode',this.reason).subscribe(
            data => {
                if(data.statusCode == 100)
                  { this.alertService.sweetMessage('success',"Added Successfully"); }
                else if(data.statusCode == 101)
                  { this.alertService.sweetMessage('error',data.responseMessage); }
                // this.alertService.sweetMessage('error',"Combination Already Exist");
            },
           error =>{
            this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
             }
        );
    }

    /* Get TechnicianList list */
    getTechnicianList() {
        this.apiService.getAll('user/getRunTimeEventTechnician?clientId=' + this.clientId + '&assetId=' + this.assetId).subscribe(
            data => {
                if (data.statusCode == 100) {
                    this.technicianList = data.userList;
                    this.temptechnicianList = data.userList;
                } else {}
            },
            error =>{
              this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
             }
        );
    }
    /* Get Event TechnicianList list */
    getEventTechnicianList() {
        this.apiService.getAll('user/getRunTimeEventTechnician?clientId=' + this.clientId + '&assetId=' + this.assetId).subscribe(
            data => {
                if (data.statusCode == 100) {
                    this.technicianList = data.userList;
                    this.eventTemptechnicianList = data.userList;
                } else {}
            },
            error =>{
              this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
             }
        );
    }

    /* Get responsibiltyList list */
    getResponsibilty() {
        this.apiService.getAll('listMember/listMemberByListType?assetId='+this.assetId+'&clientId='+this.clientId+'&runTimeEventId='+this.eventId+'&listType=1').subscribe(
            data => {
                if (data.statusCode == 100) {
                    this.responsibiltyList = data.responseList;
                    this.tempresponsibiltyList = data.responseList;

                } else {

                }
            },
            error =>{
              this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
             }
        );
    }

    /* Get responsibiltyList list */
    eventGetResponsibilty() {
        this.apiService.getAll('listMember/listMemberByListType?assetId='+this.assetId+'&clientId='+this.clientId+'&runTimeEventId='+this.eventId+'&listType=1').subscribe(
            data => {
                if (data.statusCode == 100) {
                    this.eventResponsibiltyList = data.responseList;
                    this.eventTempresponsibiltyList = data.responseList;

                } else {

                }
            },
            error =>{
              this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
             }
        );
    }

    submitruntime() {
        if (this.runTimeEvent.isParent) {
            this.runTimePutObject.runTimeEventId = this.RunTimeeventData.runTimeEventId //this.eventId
        }
        if (this.eventIdArr.length > 0) {
            this.runTimePutObject.runTimeEventId = this.RunTimeeventData.runTimeEventId //this.eventId
        }


        let self = this;
        if (Object.keys(this.responeList).length >= 2) {
            let obj = _.find(this.responsibiltyList, function(o) { return o.listMemberId == self.responeList.listMemberId; });
            this.responeList.responsibilityName = obj.name
            this.responsibilities.push(this.responeList);
        }
        if (Object.keys(this.technicians).length >= 1) {
            let obj = _.find(this.technicianList, function(o) { return o.userId == self.technicians.userId; });
            this.technicianData.push(obj);
        }

        let user = [],res = [];
        this.technicianData.map((val,index)=>{
            user.push({userId:val.userId})
        })
        this.responsibilities.map((val,index)=>{
            res.push({
                "runTimeEventRcpId": this.rcpId,
                "responsibilityListMember": {
                  "listMemberId": val.listMemberId
                },

                "downtime": val.downtime
              })
        })

        this.runTimePutObject.users = user;
        this.runTimePutObject.runTimeEventResponsibilities = res;
        this.runTimePutObject.childRunTimeEvents = this.eventIdArr;

        this.apiService.update('runTimeEvent/updateRunTimeEvents?userId='+this.userId, this.runTimePutObject).subscribe(
            data => {
                if (data.statusCode == 100) {
                    this.alertService.sweetMessage('success',data.responseMessage);
                    this.getRunTimeEventData();
                }else{
                    this.alertService.sweetMessage('error',data.responseMessage);
                }
            },
           error =>{
            this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
             }
        );
    }

    getSubTotalDownTime() {
        let total = 0;
        _.map(this.responsibilities, function(value, key) {
            total = total + parseInt(value.downtime);
        });
        return total;
    }

    getDateDiff(start, end) {
        return moment(end).diff(moment(start), "minute")
    }

    gettechnicianDetail(index) {
        this.technicians = this.technicianList[index];
    }

    /* get Responsibilty in array */
    getresponsibiltyDetail(index,event) {
        this.responeList.responsibilityName = this.responsibiltyList[event.target["selectedIndex"]-1].name;
    }

    eventGetresponsibiltyDetail(index,event){
        this.eventResponeList.responsibilityName = this.eventResponsibiltyList[event.target["selectedIndex"]-1].name;
    }

    /* Add Response in array */
    addresponses() {
        let self = this
        if (Object.keys(this.responeList).length >= 2) {
            let obj = _.find(this.responsibiltyList, function(o) { return o.listMemberId == self.responeList.listMemberId; });
            this.responeList.responsibilityName = obj.name
            this.responsibilities.push(this.responeList);
        }
        this.pushResponseListData();
    }

    eventAddresponses(){
        let self = this
        if (Object.keys(this.eventResponeList).length >= 2) {
            let obj = _.find(this.eventResponsibiltyList, function(o) { return o.listMemberId == self.eventResponeList.listMemberId; });
            this.eventResponeList.responsibilityName = obj.name
            this.responsibilities.push(this.eventResponeList);
        }
        this.eventPushResponseListData();
    }
    // Function to push data
    pushResponseListData(){
        this.tempresponsibiltyList = [];
        this.responeList = {};
        let IdArr = [];
        let ObjArr = [];
        this.responsibilities.map((obj,i)=>{
            IdArr.push(parseInt(obj.listMemberId))
        })
        this.responsibiltyList.map((val,index)=>{
            if(IdArr.indexOf(val.listMemberId)==-1){
                ObjArr.push(val)
            }
        })
        this.tempresponsibiltyList = ObjArr;
    }

    // Function to push data
    eventPushResponseListData(){
        this.tempresponsibiltyList = [];
        this.eventResponeList = {};
        let IdArr  = [];
        let ObjArr = [];

        this.responsibilities.map((obj,i)=>{
            IdArr.push(parseInt(obj.listMemberId))
        })

        this.responsibiltyList.map((val,index)=>{
            if(IdArr.indexOf(val.listMemberId)==-1){
              ObjArr.push(val)
            }
        })
        this.tempresponsibiltyList = ObjArr;
    }

    eventRemoveResponseData(i){
        this.responsibilities.splice(i,1);
        this.eventPushResponseListData();
    }

    removeResponseData(i){
        this.responsibilities.splice(i,1);
        this.pushResponseListData();
    }

    /* Add Technician in array */
    addtechnician() {
        let self = this
        if(this.technicians.userId){
            if (Object.keys(this.technicians.userId).length >= 1) {
                let obj = _.find(this.technicianList, function(o) { return o.userId == self.technicians.userId; });
                // this.technicians = obj
                this.technicianData.push(obj);
            }
        }
        this.pushTechnicaldatalist();
    }

    /* Add Technician in array */
    addEventTechnician() {
        let self = this
        if(this.eventtechnicians.userId){
            if (Object.keys(this.eventtechnicians.userId).length >= 1) {
                let obj = _.find(this.technicianList, function(o) { return o.userId == self.eventtechnicians.userId; });
                // this.technicians = obj
                this.eventTechnicianData.push(obj);
            }
        }
        this.pushEventTechnicaldatalist();
    }
    pushEventTechnicaldatalist(){
        this.eventTemptechnicianList = [];
        this.eventtechnicians = {};
        let IdArr = [];
        let ObjArr = [];

        this.eventTechnicianData.map((obj,i)=>{
            IdArr.push(parseInt(obj.userId))
        })
        this.technicianList.map((val,index)=>{
            if(IdArr.indexOf(val.userId)==-1){
                ObjArr.push(val)
            }
        })
        this.eventTemptechnicianList = ObjArr;
    }

    pushTechnicaldatalist(){
        this.temptechnicianList = [];
        this.technicians = {};
        let IdArr = [];
        let ObjArr = [];

        this.technicianData.map((obj,i)=>{
            IdArr.push(parseInt(obj.userId))
        })
        this.technicianList.map((val,index)=>{
            if(IdArr.indexOf(val.userId)==-1){
                ObjArr.push(val)
            }
        })
        this.temptechnicianList = ObjArr;
    }

     eventPushTechnicaldatalist(){
        this.eventTemptechnicianList = [];
        this.eventtechnicians = {};
        let IdArr = [];
        let ObjArr = [];

        this.eventTechnicianData.map((obj,i)=>{
            IdArr.push(parseInt(obj.userId))
        })
        this.technicianList.map((val,index)=>{
            if(IdArr.indexOf(val.userId)==-1){
                ObjArr.push(val)
            }
        })
        this.eventTemptechnicianList = ObjArr;
    }

    removetechnicalData(i){
        this.technicianData.splice(i,1);
        this.pushTechnicaldatalist();
    }

    removeEventTechnicalData(i){
        this.eventTechnicianData.splice(i,1);
        this.eventPushTechnicaldatalist();
    }
    // Getting Event List
    getRunTimeEvenList() {
        this.apiService.getAll('runTimeEvent/runTimeEventDetail?runTimeEventId=' + this.runTimeEventDataId).subscribe(
            data => {
                if (data.statusCode == 100) {

                    this.runTimetechEventData = data.response;

                    if (this.runTimetechEventData.reasonCode == null) {
                        this.runTimetechEventData.reasonCode = {};
                    }

                    this.rollupEvents = data.response.childRunTimeEvents;
                    this.technicalDetailData = data.response.users;
                    this.responsibilityDetailData = data.response.runTimeEventResponsibilities;
                } else {}
            },
            error =>{
              this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
             }
        );
    }

    // Getting Event List
    getEventRunTimeEvenList() {
        this.apiService.getAll('runTimeEvent/runTimeEventDetail?runTimeEventId=' + this.runTimeEventDataId).subscribe(
            data => {
                if (data.statusCode == 100) {

                    this.eventRunTimetechEventData = data.response;

                    if (this.eventRunTimetechEventData.reasonCode == null) {
                        this.eventRunTimePutObject.reasonCode = {};
                    }else{
                        this.eventRunTimePutObject.reasonCode=this.eventRunTimetechEventData.reasonCode;
                    }
                    this.eventRunTimePutObject.comment = this.eventRunTimetechEventData.comment;
                    this.eventTechnicianData = data.response.users;
                    /*this.rollupEvents = data.response.childRunTimeEvents;

                    this.responsibilityDetailData = data.response.runTimeEventResponsibilities;*/
                } else {}
            },
            error => {
              this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
            }
        );
    }
    // Getting Reason Code
    getRunTimeEvenListForreasonCode() {
        this.apiService.getAll('reasonCode/getReasonCodeList?clientId=' + this.clientId).subscribe(
            data => {
                if (data.statusCode == 100) {
                    this.reasonListData = data.responseList;
                } else {}
            },
           error =>{
            this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
             }
        );
    }

    // function called on check box change
    changeCheckBox(event,roleup){
        let index = _.findIndex(this.eventIdArr, { 'runTimeEventId': roleup.runTimeEventId });

        if (event.target.checked && index==-1) {

            this.eventIdArr.push({ 'runTimeEventId': roleup.runTimeEventId })
        }else{
            this.eventIdArr.splice(index,1)
        }
    }

    // Rollup Event function
    getRollupEvent(event){
      var eventId;
      if(event.runTimeCollectionPoint == undefined){
        this.rcpId = event.runTimeCollectionPointId
      }
      else{
        this.rcpId = event.runTimeCollectionPoint.runTimeCollectionPointId
      }

      if(this.eventId == 0){
        eventId = event.runTimeEventId
      }else{
        eventId = this.eventId
      }
      // this.rcpId = event.runTimeCollectionPoint.runTimeCollectionPointId;
      this.apiService.getAll('runTimeEvent/rollUpRunTimeEvents?parentRunTimeEventId='+eventId+'&clientId='+ this.clientId+'&rcpId='+this.rcpId+'&userId='+this.userId ).subscribe(
          data => {
              if (data.statusCode == 100) {
                  let list = data.responseList;
                  let dataList = []
                  list.map((val,index)=>{
                      val.select = false;
                      dataList.push(val);
                  })
                  this.rollUpList = dataList;
              } else {}
          },
         error =>{
          this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
           }
      );
    }

    // Function to approve item
    approvedItem(){
        let obj = {
            runTimeEventId:this.runTimeEvent.runTimeEventId,
            approvedBy:{
                userId:this.userId
            },
            isApproved:true
        }
        this.apiService.update('runTimeEvent/approvedRuntimeEvent',obj ).subscribe(
            data => {
                if (data.statusCode == 100) {
                    this.getRunTimeEventData();

                } else {}
            },
            error =>{
              this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
            }
        );
    }


    notificationDetail(eventData, eventListType) {
      let runTimeStatus = eventData.runTimeStatus;
      let licenseIsAck = eventData.licenseIsAck;
      let acknowledgeByMe = eventData.acknowledgeByMe;
      let assignToMe = eventData.assignToMe;
      let technicianId = eventData.technicianId;      
      let licenseIsTechEntry = eventData.licenseIsTechEntry;
      let isAck = eventData.isAck;

      if(this.userId == eventData.technicianId && runTimeStatus == 2) {
         this.performAction = 1;
      } 

      if(licenseIsAck == true && acknowledgeByMe == false && assignToMe == true) {
        this.showAckBtn = 1;
      } else {
        this.showAckBtn = 0;
      }

      if(
        licenseIsAck == true && 
        acknowledgeByMe == false && 
        assignToMe == true && 
        (technicianId == null || technicianId == 0) && 
        licenseIsTechEntry == true && 
        runTimeStatus == 1
        ) {
        this.showAckErcBtn = 1;
      } else {
        this.showAckErcBtn = 0;
      }

      if(
        licenseIsAck == true && 
        assignToMe == true && 
        (technicianId == null || technicianId == 0) &&         
        runTimeStatus == 1
        ) {
        this.showERC = 1;
      } else {
        this.showERC = 0;
      }

      let obj = {
        id:null,
        type:null
      }
      let pVal = 0;
      if(eventData.isParent == false) {
        pVal = 0;
      } else if(eventData.isParent == true) {
        pVal = 1;
      }
      obj.type = eventData.notificationType;
      if (eventData.notificationType == "Notification") {
          obj.id = eventData.notificationId;
      } else if (eventData.notificationType == "RunTime") {
          obj.id = eventData.runTimeEventId;
      }
      if(eventListType == 'approval' || eventListType == 'approved') {
        obj.type = 'RunTime';
        obj.id = eventData.runTimeEventId;
        this.performAction = 1;
        eventData.licenseIsTechEntry = true;
      }

      this.router.navigate(["eventDetails", eventData.assetId,], 
        {
          queryParams: 
          { 
            type: obj.type, 
            id :obj.id, 
            rcpId:eventData.runTimeCollectionPointId, 
            notificationId : eventData.notificationId, 
            isParent : pVal, 
            performAction : this.performAction, 
            showAckBtn : this.showAckBtn,
            showAckErcBtn : this.showAckErcBtn,
            showERC : this.showERC,
            licenseIsTechEntry : eventData.licenseIsTechEntry, 
            eventListType : eventListType,
            assignToMe : assignToMe == true ? 1 : 0,
            isAck : isAck == true ? 1 : 0
          }
      });
    }


  rowTrackByFunction(index, item) {
    // You will want to return a unique primitive for angular to use as a comparison item
    // (string, number, etc.)
    return index;//item.someUniqueIdentifier;
 }

 getHistory(obj){
  this.HistoryList = []
  let URL = ''
  if (obj.notificationType == 'Notification') {
    URL = 'runTimeEvent/getRuntimeEventHistoryDetail?eventId='+obj.notificationId+'&isevent=false'
    // URL = 'runTimeEvent/getRuntimeEventHistoryDetail?eventId='+943731+'&isevent=true'
  }else{
    URL = 'runTimeEvent/getRuntimeEventHistoryDetail?eventId='+obj.runTimeEventId+'&isevent=true'
  }

  if ($.fn.DataTable.isDataTable('#HistoryDatatable')) {
    $('#HistoryDatatable').DataTable({ "order": [], "destroy": true }).destroy();
  };
      this.apiService.getAll(URL).subscribe(
        data => {
          if (data.statusCode == 100) {
            this.HistoryList = data.responseList;
            setTimeout(() => {
              const table: any = $('#HistoryDatatable');
               table.DataTable({ "order": [], "destroy": true });
            }, 500);
          } else {
            setTimeout(() => {
              const table: any = $('#HistoryDatatable');
               table.DataTable({ "order": [], "destroy": true });
            }, 500);
            Swal({
              position: 'top-end',
              type: 'error',
              title: data.responseMessage,
              showConfirmButton: false,
              timer: 1500
            })
          }
        },
        error => {
          this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
        }
      ); 
}

getItemWaitingHistory(obj){
  this.HistoryList = []
  console.log(obj);
  
  let URL = ''
  // if (obj.notificationType == 'Notification') {
  //   URL = 'runTimeEvent/getRuntimeEventHistoryDetail?eventId='+obj.notificationId+'&isevent=false'
  //   // URL = 'runTimeEvent/getRuntimeEventHistoryDetail?eventId='+943731+'&isevent=true'
  // }else{
    URL = 'runTimeEvent/getRuntimeEventHistoryDetail?eventId='+obj.runTimeEventId+'&isevent=true'
  // }

  if ($.fn.DataTable.isDataTable('#HistoryDatatable')) {
    $('#HistoryDatatable').DataTable({ "order": [], "destroy": true }).destroy();
  };
      this.apiService.getAll(URL).subscribe(
        data => {
          if (data.statusCode == 100) {
            this.HistoryList = data.responseList;
            setTimeout(() => {
              const table: any = $('#HistoryDatatable');
               table.DataTable({ "order": [], "destroy": true });
            }, 500);
          } else {
            setTimeout(() => {
              const table: any = $('#HistoryDatatable');
               table.DataTable({ "order": [], "destroy": true });
            }, 500);
            Swal({
              position: 'top-end',
              type: 'error',
              title: data.responseMessage,
              showConfirmButton: false,
              timer: 1500
            })
          }
        },
        error => {
          this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
        }
      ); 
}
setResponsibilityList(list){
  this.responsibilityList = list
}

setEventrollupLists(list){
  this.rollUpEventList = list
}
getCommentDecoded(comment){
  return decodeURIComponent(comment)
}

onHoverPosition(event){
  $(document).ready(function(){
    $('.Alarm.map-status').mousemove(function(event) { 
        // var left = event.pageX - $(this).offset().left + 100;
        // var top = event.pageY - $(this).offset().top + 130;
        console.log(event.pageX - $(this).offset().left,  $(this).offset().left,event.pageX, $(this).children('.map-text').position());
        console.log($(this).children('.map-text').position().left , $(this).children('.map-text').position().top);
        
        
        // $('#gas-electric-hover').css({top: top,left: left}).show();
        //console.log (left, top);
    });
//     $('#utilities').mouseout(function() {
//         $('#gas-electric-hover').hide();
//     });
});  
}

}
